import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';

export enum UnsavedChangesDialogResult {
  Cancel = 'cancel',
  Discard = 'discard',
  Save = 'save'
}

export interface UnsavedChangesDialogData {
  canDiscard: boolean;
  canSave: boolean;
  context?: string;
};

@Component({
  templateUrl: 'unsaved-changes.dialog.html',
  styleUrls: ['./unsaved-changes.dialog.scss'],
  standalone: false
})
export class UnsavedChangesDialog {
  constructor(
    public dialogRef: MatDialogRef<UnsavedChangesDialog>,
    @Inject(MAT_DIALOG_DATA) public data: UnsavedChangesDialogData) {
  }

  cancel() {
    this.dialogRef.close(UnsavedChangesDialogResult.Cancel);
  }

  discard() {
    this.dialogRef.close(UnsavedChangesDialogResult.Discard);
  }

  save() {
    this.dialogRef.close(UnsavedChangesDialogResult.Save);
  }
}
